import { ChangeDetectorRef, Component, HostListener } from '@angular/core'
import { tap } from 'rxjs/operators'
import { ERROR } from './classes/errors.model'
import { ClientService } from './services/client.service'
import { SpinnerService } from './services/spinner.service'
import { StepperService } from './services/stepper.service'

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'comafi-landing'
  cargado = false
  message: string
  userActivity
  eventoDisparado = false
  @HostListener('window:beforeunload', ['$event'])
  WindowBeforeunload(e: any) {
    if (!this.clientService.activeAlertClose) {
      e.preventDefault()
      const confirmationMessage = 'o/'
      // tslint:disable-next-line: deprecation
      ;(e || window.event).returnValue = confirmationMessage
    }
  }
  @HostListener('window:unload', ['$event'])
  WindowOnunload($event: any) {
    //sessionStorage.setItem('inicio_session', '0')
    if (this.clientService.client.id_tramite) {
      const info = this.clientService.postEventosSync(
        'Sesion cerrada',
        'eventos_aplicativo'
      )
    }
  }

  @HostListener('window:mousemove')
  refreshUserState() {
    clearTimeout(this.userActivity)
    this.Inactividad()
  }
  @HostListener('window:keypress')
  refreshUserStatesKey() {
    clearTimeout(this.userActivity)
    this.Inactividad()
  }
  @HostListener('window:touchmove')
  refreshUserStatesMove() {
    clearTimeout(this.userActivity)
    this.Inactividad()
  }
  @HostListener('window:touchstart')
  refreshUserStatesTouch() {
    clearTimeout(this.userActivity)
    this.Inactividad()
  }

  constructor(
    private spinnerService: SpinnerService,
    private stepperService: StepperService,
    private changeDetector: ChangeDetectorRef,
    private clientService: ClientService
  ) {
    setTimeout(() => {
      this.spinnerService.showSpinner()
      this.stepperService.cargadoResolver
        .pipe(
          tap((data) => {
            this.spinnerService.hideSpinner()
            this.cargado = data
          })
        )
        .subscribe()
    })
  }

  Inactividad() {
    this.userActivity = setTimeout(() => {
      if (!this.clientService.getRecorridoFinalizado()) {
        this.stepperService.setSwicthInactividad(true)
        this.stepperService.setErrorGenerico(
          ERROR.sesion_expirada.update({
            btn:
              'Volver a comenzar | ' +
              this.clientService.GetSStorageVuelta().link,
          })
        )
        if (this.clientService.client.id_tramite) {
          const info = this.clientService.postEventosSync(
            'Sesion expirada por inactividad',
            'eventos_aplicativo'
          )
        }
        clearTimeout(this.userActivity)
      }
    }, 180000)
  }
  ngAfterViewChecked() {
    document.getElementById('back').click()
  }
  ngOnInit() {
    this.spinnerService.showSpinner()
    this.Inactividad()
  }
  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges()
  }
}
